import React from 'react';
import './style.css';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  closeOnBackdrop?: boolean; // default true
  children?: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, closeOnBackdrop = true, children }) => {
  if (!isOpen) return null;

  const handleBackdropClick = () => {
    if (closeOnBackdrop) onClose();
  };

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="modal-container modal-content-width" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close-btn" onClick={onClose} aria-label="Close modal">×</button>
        <div className="modal-children">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
